// extracted by mini-css-extract-plugin
export default {"signup-payment-page":"SignUpPaymentPage_signup-payment-page__GFTr6"};